import { render, staticRenderFns } from "./PartnerPart.vue?vue&type=template&id=3d6b5dd0&scoped=true&"
import script from "./PartnerPart.vue?vue&type=script&lang=js&"
export * from "./PartnerPart.vue?vue&type=script&lang=js&"
import style0 from "./PartnerPart.vue?vue&type=style&index=0&id=3d6b5dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b5dd0",
  null
  
)

export default component.exports